const url = "https://api.formaxpay.com/api/";

exports.baseUrl = url;
